import React from "react";
import { useTranslation } from "react-i18next";
import calendar from "../../assets/icons/calendar.svg";
import clock from "../../assets/icons/clock.svg";
import mapPin from "../../assets/icons/map_pin.svg";
import { Ticket } from "./Ticket";
import styles from "./TicketsList.module.css";

const tickets: Ticket[] = [
  {
    id: 1,
    venue: "Teatr Lalek Rabcio w Rabce-Zdroju",
    image: "",
    date: new Date("2025-04-06"),
    time: "18:00",
    location: "Orkana 3c, 34-700 Rabka-Zdrój",
    locationLink:
      "https://www.google.com/maps/place/Teatr+LALEK+RABCIO/@49.6107607,19.9483593,17z/data=!3m1!4b1!4m6!3m5!1s0x47160a83523c5d4f:0x66ee21e157a7af03!8m2!3d49.6107607!4d19.9483593!16s%2Fg%2F1tcztpd3?entry=ttu&g_ep=EgoyMDI1MDIxNy4wIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D",
    price: 0,
    program: ["programFilmMusic"],
    freeAdmission: false,
    ticketLink: "",
    additionalInformation: "",
  },
  {
    id: 2,
    venue: `Centrum Kultury i Filmu im. Billy'ego Wildera w Suchej Beskidzkiej`,
    image: "",
    date: new Date("2025-05-04"),
    time: "18:00",
    location: "Adama Mickiewicza 27, 34-200 Sucha Beskidzka",
    locationLink:
      "https://www.google.com/maps/place//data=!4m2!3m1!1s0x47167f12ef6f0df5:0x6d67052133900e0a?sa=X&ved=1t:8290&ictx=111",
    price: 50,
    program: ["programFilmMusic"],
    freeAdmission: false,
    ticketLink: "",
    additionalInformation: "ticketsList.additionalTicketInformation1",
  },
  {
    id: 3,
    venue: `Centrum Kongresowe Szczawnica - Dworek Gościnny`,
    image: "",
    date: new Date("2025-05-24"),
    time: "",
    location: "Park Górny 7, 34-460 Szczawnica",
    locationLink:
      "https://www.google.com/maps/place//data=!4m2!3m1!1s0x473e0678f47d8b4b:0xdcd7f5079c300ac4?sa=X&ved=1t:8290&ictx=111",
    price: 0,
    program: ["programFilmMusic"],
    freeAdmission: false,
    ticketLink: "",
    additionalInformation: "",
  },
  {
    id: 4,
    venue: `Miejskie Centrum Kultury w Nowym Targu`,
    image: "",
    date: new Date("2025-06-01"),
    time: "",
    location: "Aleja Tysiąclecia 37, 34-400 Nowy Targ",
    locationLink:
      "https://www.google.com/maps/place//data=!4m2!3m1!1s0x4715e4ef3f9b5273:0x89aaaacd6d35185a?sa=X&ved=1t:8290&ictx=111",
    price: 0,
    program: ["programFilmMusic"],
    freeAdmission: false,
    ticketLink: "",
    additionalInformation: "",
  },
  {
    id: 5,
    venue: `Kieleckie Centrum Kultury`,
    image: "",
    date: new Date("2025-09-07"),
    time: "",
    location: "Plac Stanisława Moniuszki 2B, 25-334 Kielce",
    locationLink:
      "https://www.google.com/maps/place//data=!4m2!3m1!1s0x4718279191efeb15:0xe1796b1a75c32abc?sa=X&ved=1t:8290&ictx=111",
    price: 0,
    program: ["programFilmMusic"],
    freeAdmission: false,
    ticketLink: "",
    additionalInformation: "",
  },
  {
    id: 6,
    venue: `Makowskie Centrum Kultury "Dni Makowa 2025"`,
    image: "",
    date: new Date("2025-07-13"),
    time: "",
    location: "3 Maja 51, 34-220 Maków Podhalański",
    locationLink:
      "https://www.google.com/maps/place//data=!4m2!3m1!1s0x4716790502c7542d:0xb9131458ea46f28f?sa=X&ved=1t:8290&ictx=111",
    price: 0,
    program: ["programFilmMusic"],
    freeAdmission: true,
    ticketLink: "",
    additionalInformation: "",
  },
];

const TicketsList: React.FC = () => {
  const { t } = useTranslation();
  const now = new Date();

  const upcomingTickets = tickets
    .filter((ticket) => ticket.date >= now)
    .sort((a, b) => a.date.getTime() - b.date.getTime());
  const pastTickets = tickets
    .filter((ticket) => ticket.date < now)
    .sort((a, b) => a.date.getTime() - b.date.getTime());

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = t(`months.${date.getMonth()}`);
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  return (
    <div className={styles.ticketsList}>
      {upcomingTickets.map((ticket) => (
        <div key={ticket.id} className={styles.ticketCard}>
          {ticket.freeAdmission && (
            <div className={styles.freeAdmissionBadge}>
              {t("ticketsList.freeAdmission")}
            </div>
          )}
          <div className={styles.details}>
            <h2>{ticket.venue}</h2>

            <div className={styles.infoGrid}>
              <div className={styles.info}>
                <a
                  href={ticket.locationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className={styles.locationNameContainer}>
                    <img src={mapPin} alt="location" className={styles.icon} />
                    <span className={styles.locationName}>
                      {ticket.location}
                    </span>
                  </div>
                  <span className={styles.locationButton}>
                    {t("ticketsList.viewOnMap")}
                  </span>
                </a>
              </div>
              <div className={styles.info}>
                <img src={clock} alt="hour" className={styles.icon} />
                <span>
                  {ticket.time ? (
                    ticket.time
                  ) : (
                    <span className={styles.noInformationText}>
                      {t("ticketsList.noInformation")}
                    </span>
                  )}
                </span>
              </div>
              <div className={styles.info}>
                <img src={calendar} alt="date" className={styles.icon} />
                <span>{formatDate(ticket.date.toString())}</span>
              </div>
            </div>

            <div className={styles.program}>
              <h3>{t("ticketsList.program")}</h3>
              <ul>
                {ticket.program.map((item, index) => (
                  <li key={index}>{t(`ticketsList.${item}`)}</li>
                ))}
              </ul>
            </div>

            <div className={styles.bottom}>
              <div className={styles.price}>
                <span
                  className={styles.priceLabel}
                  dangerouslySetInnerHTML={{
                    __html: t("ticketsList.ticketPrice"),
                  }}
                ></span>
                {ticket.freeAdmission ? (
                  <span
                    className={`${styles.priceAmount} ${styles.priceAmountFree}`}
                  >
                    0 zł
                  </span>
                ) : ticket.price !== 0 ? (
                  <span className={styles.priceAmount}>{ticket.price} zł</span>
                ) : (
                  <span className={styles.noInformationText}>
                    {t("ticketsList.noInformation")}
                  </span>
                )}
              </div>
              {!ticket.freeAdmission && (
                <a
                  href={ticket.ticketLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={ticket.price === 0 ? styles.desaturation : ""}
                >
                  <button className={styles.buyButton}>
                    {t("ticketsList.buyTicket")}
                  </button>
                </a>
              )}
            </div>
            <span className={styles.additionalInformation}>
              {t(ticket.additionalInformation)}
            </span>
          </div>
        </div>
      ))}
      {pastTickets.map((ticket) => (
        <div
          key={ticket.id}
          className={`${styles.ticketCard} ${styles.desaturation}`}
        >
          {ticket.freeAdmission && (
            <div className={styles.freeAdmissionBadge}>
              {t("ticketsList.freeAdmission")}
            </div>
          )}
          <div className={styles.details}>
            <h2>{ticket.venue}</h2>

            <div className={styles.infoGrid}>
              <div className={styles.info}>
                <a
                  href={ticket.locationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className={styles.locationNameContainer}>
                    <img src={mapPin} alt="location" className={styles.icon} />
                    <span className={styles.locationName}>
                      {ticket.location}
                    </span>
                  </div>
                </a>
              </div>
              <div className={styles.info}>
                <img src={clock} alt="hour" className={styles.icon} />
                <span>
                  {ticket.time ? (
                    ticket.time
                  ) : (
                    <span className={styles.noInformationText}>
                      {t("ticketsList.noInformation")}
                    </span>
                  )}
                </span>
              </div>
              <div className={styles.info}>
                <img src={calendar} alt="date" className={styles.icon} />
                <span>{formatDate(ticket.date.toString())}</span>
              </div>
            </div>

            <div className={styles.program}>
              <h3>{t("ticketsList.program")}</h3>
              <ul>
                {ticket.program.map((item, index) => (
                  <li key={index}>{t(`ticketsList.${item}`)}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TicketsList;
